import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';
import { createLocalId } from '../../../utils/local-id';

export function* createAttachment(cardId, data) {
  const localId = yield call(createLocalId);

  // FAMILY-EXT: webdav-вложение — data.externalPath вместо data.file.
  // Используем отдельный endpoint, имя берём из data.name или basename
  // пути.
  const isWebdav = !!data.externalPath;
  const optimisticName = isWebdav
    ? data.name || data.externalPath.split('/').filter(Boolean).pop() || 'webdav'
    : data.file.name;

  yield put(
    actions.createAttachment({
      cardId,
      id: localId,
      name: optimisticName,
      // FAMILY-EXT: для оптимистичного рендера сразу проставим type
      ...(isWebdav && {
        type: 'webdav',
        externalPath: data.externalPath,
      }),
    }),
  );

  let attachment;
  try {
    ({ item: attachment } = isWebdav
      ? yield call(request, api.createWebdavAttachment, cardId, data, localId)
      : yield call(request, api.createAttachment, cardId, data, localId));
  } catch (error) {
    yield put(actions.createAttachment.failure(localId, error));
    return;
  }

  yield put(actions.createAttachment.success(localId, attachment));
}

export function* createAttachmentInCurrentCard(data) {
  const { cardId } = yield select(selectors.selectPath);

  yield call(createAttachment, cardId, data);
}

export function* handleAttachmentCreate(attachment, requestId) {
  const isExists = yield select(selectors.selectIsAttachmentWithIdExists, requestId);

  if (!isExists) {
    yield put(actions.handleAttachmentCreate(attachment));
  }
}

export function* updateAttachment(id, data) {
  yield put(actions.updateAttachment(id, data));

  let attachment;
  try {
    ({ item: attachment } = yield call(request, api.updateAttachment, id, data));
  } catch (error) {
    yield put(actions.updateAttachment.failure(id, error));
    return;
  }

  yield put(actions.updateAttachment.success(attachment));
}

export function* handleAttachmentUpdate(attachment) {
  yield put(actions.handleAttachmentUpdate(attachment));
}

export function* deleteAttachment(id) {
  yield put(actions.deleteAttachment(id));

  let attachment;
  try {
    ({ item: attachment } = yield call(request, api.deleteAttachment, id));
  } catch (error) {
    yield put(actions.deleteAttachment.failure(id, error));
    return;
  }

  yield put(actions.deleteAttachment.success(attachment));
}

export function* handleAttachmentDelete(attachment) {
  yield put(actions.handleAttachmentDelete(attachment));
}

export default {
  createAttachment,
  createAttachmentInCurrentCard,
  handleAttachmentCreate,
  updateAttachment,
  handleAttachmentUpdate,
  deleteAttachment,
  handleAttachmentDelete,
};
